<template>
    <path fill-rule="evenodd" d="M16 0C7.164 0 0 7.167 0 16c0 8.839 7.164 16 16 16s16-7.161 16-16c0-8.833-7.164-16-16-16zm0 28.903c-7.131 0-12.903-5.77-12.903-12.903C3.097 8.871 8.869 3.097 16 3.097c7.128 0 12.903 5.772 12.903 12.903S23.133 28.903 16 28.903zm0-21.806c1.497 0 2.71 1.213 2.71 2.71 0 1.496-1.213 2.71-2.71 2.71-1.497 0-2.71-1.214-2.71-2.71 0-1.497 1.213-2.71 2.71-2.71zm3.613 16.387c0 .427-.347.774-.774.774H13.16c-.427 0-.774-.347-.774-.774v-1.549c0-.427.347-.774.774-.774h.774v-4.129h-.774c-.427 0-.774-.346-.774-.774V14.71c0-.428.347-.775.774-.775h4.13c.427 0 .774.347.774.775v6.451h.774c.427 0 .774.347.774.774v1.549z"/>
</template>

<script>
export default {
    name: 'notificationInfoIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
